import $ from "jquery";
import { application } from "../application/application";
import { attestationsDashboardFilters } from "./attestationsDashboardFilters";
import { attestationsSearch } from "./attestationsSearch";
import { forms } from "../framework/forms";

let dataSet = [];
let attestationsTable;
let currentPage = 1;
let hasNextPage = false;
const tableColumns = [
    "Id",
    "AttestationName",
    "AttestationTypeName",
    "AttestationDescription",
    "AttestationStartDateUtc",
    "AttestationEndDateUtc",
    "IsGlobal",
    "IsActive",
    "CurrentStatus"
];
let sort = null;
let onPopulateTable = function() {};

function init() {
    buildTable();
    attestationsDashboardFilters.doSetup();
    populateTable();
    setEvents();
}

function setEvents() {
    $("#btnDownloadExcelCurrPage").click(function() {
        $(this).attr("href", exportAttestationsToExcel(false));
    });

    $("#btnDownloadExcelAll").click(function() {
        if (isFilterEmpty()) {
            $(this).attr("href", "#");
            alert("Please enter search criteria.");
            return false;
        } else {
            $(this).attr("href", exportAttestationsToExcel(true));
        }
    });

    $(document).on("mouseover", "#attestationsTable tbody tr", function() {
        attestationsTable.$(".dropdown").hide();
        $(this)
            .find(".dropdown")
            .show();
    });

    $(document).on("mouseleave", "#attestationsTable", function() {
        attestationsTable.$(".dropdown").hide();
    });

    //Set double click attestation select for grid.
    $(document).on("dblclick", "#attestationsTable tbody tr", function() {
        const data = attestationsTable.row(this).data();
        if (data === undefined) {
            return;
        }
        forms.showSpinner();
        window.location.href = application.baseUrl + "/attestation/index/" + data[0];
    });

    $(
        "#attestationsTable .sorting, #attestationsTable .sorting_asc, #attestationsTable .sorting_desc"
    ).click(function(e) {
        const asc = $(this).hasClass("sorting") || $(this).hasClass("sorting_desc");
        $(".sorting, .sorting_asc, .sorting_desc")
            .removeClass()
            .addClass("sorting");

        if (asc) {
            $(this)
                .removeClass("sorting")
                .removeClass("sorting_desc")
                .addClass("sorting_asc");
        } else {
            $(this)
                .removeClass("sorting")
                .removeClass("sorting_asc")
                .addClass("sorting_desc");
        }
        $(".sorting, .sorting_asc, .sorting_desc")
            .not($(this))
            .removeClass(".sorting_asc")
            .removeClass(".sorting_desc")
            .addClass("sorting");

        sort = {
            column: tableColumns[attestationsTable.column(this).index()],
            columnIndex: attestationsTable.column(this).index(),
            desc: $(this).hasClass("sorting_desc")
        };
        attestationsDashboardFilters.setSort(sort.column, sort.columIndex, sort.desc);
        applyFilters();
    });

    $("#previous").addClass("disabled");

    $("#next").click(goNextPage);

    $("#previous").click(goPreviousPage);

    $("#applyFilters").click(applyFilters);

    $("#clearFilters").click(clearFilters);

    $("#attestations-search").submit(function(e) {
        e.preventDefault();
        applyFilters();
    });
    if ($.isFunction(onPopulateTable)) {
        onPopulateTable(attestationsTable);
    }
    //Set up role dropdown display and events.
}

function isFilterEmpty() {
    const filters = attestationsDashboardFilters.setFilters();
    return filters.keyword === "";
}

function exportAttestationsToExcel(getAll) {
    let source = "";
    if (getAll) {
        source = "/Attestations/GetAttestationSearchExcel" + "/-1/?";
    } else {
        source = "/Attestations/GetAttestationSearchExcel" + "/" + currentPage + "/?";
    }
    const sourceWithParams = (source += $.param(
        attestationsDashboardFilters.getQueryStringFilters()
    ).replace(/%5B%5D/g, ""));
    return sourceWithParams;
}

function setNextPrevButtonEnabled() {
    if (!hasNextPage) {
        $("#next").addClass("disabled");
    } else {
        $("#next").removeClass("disabled");
    }
    if (currentPage === 1) {
        $("#previous").addClass("disabled");
    } else {
        $("#previous").removeClass("disabled");
    }
}

function buildTable() {
    //Set up person grid.
    attestationsTable = $("#attestationsTable").DataTable({
        //"processing": true, // for show progress bar
        serverSide: false, // for process server side
        filter: false, // this is for disable filter (search box)
        //"orderMulti": false, // for disable multiple column at once
        data: dataSet,
        lengthChange: false,
        paginate: false,
        pageLength: 20,
        info: false,
        ordering: false,
        columnDefs: [
            {
                targets: 0,
                visible: false
            },
            {
                targets: 1,
                name: "attestationName"
            },
            {
                targets: 2,
                name: "attestationTypeName"
            },
            {
                targets: 3,
                name: "attestationDescription"
            },
            {
                targets: 4,
                name: "attestationStartDateUtc"
            },
            {
                targets: 5,
                name: "attestationEndDateUtc"
            },
            {
                targets: 6,
                name: "isGlobal"
            },
            {
                targets: 7,
                name: "isActive"
            },
            {
                targets: 8,
                name: "currentStatus"
            }
        ]
    });
    attestationsDashboardFilters.setAttestationsTable(attestationsTable);
}
function goNextPage() {
    if (!hasNextPage) return;
    currentPage++;
    populateTable();
}

function goPreviousPage() {
    if (currentPage === 1) return;
    currentPage--;
    populateTable();
}

function applyFilters() {
    currentPage = 1;
    attestationsDashboardFilters.setFilters();
    populateTable();
}

function clearFilters() {
    currentPage = 1;
    attestationsDashboardFilters.clearFilters();
    populateTable();
}

function populateTable() {
    const filters = attestationsDashboardFilters.getFilters();
    filters.currentPage = currentPage;
    return $.Deferred(function(def) {
        attestationsSearch.getAttestations(currentPage, filters).done(function(results) {
            attestationsTable.clear();
            dataSet = [];
            for (let i = 0; i < results.attestations.length; i++) {
                const row = [
                    results.attestations[i].id,
                    results.attestations[i].attestationName,
                    results.attestations[i].attestationTypeName,
                    results.attestations[i].attestationDescription,
                    results.attestations[i].attestationStartDateUtc,
                    results.attestations[i].attestationEndDateUtc,
                    results.attestations[i].isGlobal,
                    results.attestations[i].isActive,
                    results.attestations[i].currentStatus
                ];
                dataSet.push(row);
            }
            attestationsTable.rows
                .add(dataSet)
                .columns.adjust()
                .draw();
            attestationsTable.$(".dropdown").hide();
            hasNextPage = results.attestations.length > 20;
            setNextPrevButtonEnabled();

            if ($.isFunction(onPopulateTable)) {
                onPopulateTable(attestationsTable);
            }
            def.resolve();
        });
    }).promise();
}

function getAttestationTable() {
    return attestationsTable;
}
function setOnPopulateTable(functionPointer) {
    if (!$.isFunction(functionPointer)) return;
    onPopulateTable = functionPointer;
}

export const attestationsDashboard = {
    init: init,
    getAttestationTable: getAttestationTable,
    setOnPopulateTable: setOnPopulateTable
};
